<!-- 
Toggle button for switching the listing of notices between a timeline style view and a listing style view.
-->
<template>
  <v-toolbar dense flat color="white" class="pl-1">
    <v-btn-toggle 
      :value="toggleButtonValue"
      class="mb-2 mt-2 elevation-0"
      style="border: 1px solid #f0f0f0;" mandatory 
      @change="$emit('update:timeline', !timeline)"
    >
      <v-tooltip top>
        <v-btn slot="activator" flat color="primary">
          <v-icon>timeline</v-icon>
        </v-btn>
        <span>Timeline view</span>
      </v-tooltip>
      <v-tooltip top>
        <v-btn slot="activator" flat color="primary">
          <v-icon>list</v-icon>
        </v-btn>
        <span>List view</span>
      </v-tooltip>
    </v-btn-toggle>
    <our-search-button 
      v-if="!timeline"
      :criteria="criteria" 
      :criteria-mutation="criteriaMutation" 
      :search-filters="searchFilters" 
      title="Search notices"
      flat
      show-all
      @changed="$emit('changed')"
    />
    <our-saved-searches-menu
      v-if="!timeline"
      :criteria="criteria"
      :criteria-mutation="criteriaMutation"
      :clear-criteria-mutation="clearCriteriaMutation"
      module="notices" 
      color="primary"
      flat
      dense
      @selected="$emit('changed')"
    />
    <v-spacer/>
    <div v-if="timeline">
      <our-icon-button
        :icon-class="'expand-icon ' + (ascending ? 'flipped' : '')"
        tooltip="Click to toggle between ascending and descending order"
        icon="sort"
        @click="$emit('update:ascending', !ascending)"
      >
        Sorting
      </our-icon-button>
    </div>
  </v-toolbar>
</template>

<script>
/* 
Toggle buttons for the notice timeline
--------------------------------------

Shows buttons for toggling between the timeline view and the listing view for notices.
When showing the timeline view it also displays a sorting button.
When showing the listing view it also displays search and saved search buttons.
*/
import _ from "underscore";
import { getSearchFilters } from "@/store/notices/helpers";
import { LIST_SET_CRITERIA, LIST_CLEAR_CRITERIA } from "@/store/notices/mutation-types";

export default {
  model: {
    prop: "timeline",
    event: "update:timeline"
  },
  props: {
    timeline: {
      type: Boolean,
      default: true
    },
    ascending: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    toggleButtonValue() {
      return this.timeline ? 0 : 1;
    },
    criteria() {
      return this.$store.state.notices.listing.criteria;
    },
    criteriaMutation() {
      return LIST_SET_CRITERIA;
    },
    clearCriteriaMutation() {
      return LIST_CLEAR_CRITERIA;
    },
    searchFilters() {
      return _(getSearchFilters()).filter(f => f.value != "providerName" && f.value != "providerCode");
    }
  },
  watch: {
    timeline() {
      if (!this.timeline) {
        this.$store.commit(this.clearCriteriaMutation);
        this.$emit("changed");
      }
    }
  }
};
</script>
